<div #starsInput class="read-only-star"></div>
